import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageContentModel } from 'src/app/models/page-content.model';
import { environment } from 'src/environments/environment';
import { PageContentInterface } from './page-content.interface';

@Injectable()
export class PageContentService implements PageContentInterface {

  constructor(private httpClient: HttpClient) {
  }

  GetPageContentByPageName(pageName: string): Observable<PageContentModel[]> {
    return this.httpClient.get<PageContentModel[]>(environment.apiBaseUrl + `PageContent/getByPageName/${pageName}`);
  }


  testEmail(emailsToTest): Observable<any> {
    //return this.httpClient.get<any>(environment.apiBaseUrl + `email/sendTestEmail`);
    return this.httpClient.post<any>(environment.apiBaseUrl + `email/sendEmailToMultipleRecipients`,
      {
        Subject: "Test Email Subject",
        ToEmailList: emailsToTest?.split(','),
        EmailBody: "Test Email Body"
      });
  }

  // testEmailMultipleSenders(): Observable<any> {
  //   //return this.httpClient.get<any>(environment.apiBaseUrl + `email/sendTestEmail`);
  //   return this.httpClient.post<any>(environment.apiBaseUrl + `email/sendEmailToMultipleRecipients`,
  //     {
  //       Subject: "Sufian and Ram test",
  //       ToEmailList: ["mirzasufian.baig@ontario.ca","ramaprasad.kollasridhar@ontario.ca"],
  //       EmailBody: "Sufian and Ram test email message"
  //     });
  // }
}
